// @flow
import React from 'react';
import type { Node } from 'react';

import styled, { type StyledComponent } from 'styled-components';

import LoadingSpinner from '../../typography/LoadingSpinner';
import Button from '../Button';

const Spinner: StyledComponent<React$ElementConfig<typeof LoadingSpinner>, {}, any> = styled(
  LoadingSpinner
)`
  margin-left: 5px;
  transform-origin: 53% 51%;
  top: 1px;
  color: inherit;
`;

export type Props = {
  loading: boolean,
  children: Node,
};

const LoadingButton = ({ loading, children, ...other }: Props): Node => (
  <Button disabled={loading} {...other}>
    {children}
    {loading && <Spinner />}
  </Button>
);

LoadingButton.defaultProps = {
  loading: false,
};

export default LoadingButton;



// WEBPACK FOOTER //
// ../react-lib/src/components/buttons/LoadingButton/LoadingButton.jsx